export const integrationsTable = {
  header: 'Integrations',

  id: 'Integration Id',
  name: 'Name',
  type: 'Type',
  createdBy: 'Created by',
  date: 'Date',

  search: 'Search Integration ID',
};
export const rowActions = {
  view: 'View Integration Details',
  edit: 'Edit',
  delete: 'Delete',
};
